<template id="cv">
   <div class="cv-section">
      <h1>Resume</h1>
      <h2>
         I'm currently seeking a position as a Front-End or Fullstack Developer
      </h2>
      <router-link to="/resume">
         <v-btn elevation="15" x-large class="btn">
            <span>Download cv</span>
         </v-btn>
      </router-link>
   </div>
</template>

<script>
export default {
   data() {
      return {

      }
   },
   components: {
   },
   async created() {
   },
   computed: {
   },
   methods: {
   }
}
</script>

